<template>
  <div
    @click="$store.commit('modals/OPEN_ADD_VALIDATION_POPUP', false)"
    class="py-3 md-pd flex items-center w-full h-full justify-center add-validation__modal__container"
  >
    <section
      @click.stop
      class="w-11/12 md:w-1/2 lg:w-4/5 xl:w-3/4 p-4 relative"
    >
      <div
        @click="$store.commit('modals/OPEN_ADD_VALIDATION_POPUP', false)"
        class="flex absolute items-center justify-center cross-icon cursor-pointer z-20"
      >
        X
      </div>
      <div
        class="flex"
        :class="
          validationType &&
          (validationType.key === 'quiz' || validationType.key === 'attendance')
            ? 'overflow-container-quiz'
            : 'overflow-container'
        "
      >
        <vx-card
          class="scrollbarWidth"
          :class="
            validationType &&
            (validationType.key === 'quiz' ||
              validationType.key === 'attendance')
              ? 'overflow-y-scroll'
              : ''
          "
        >
          <vs-row class="flex-col">
            <h4 class="text-2xl font-bold text-left heading-black">
              {{
                assignment.libraryItemValidationData &&
                assignment.libraryItemValidationData.validationType
                  ? "Update"
                  : "Add"
              }}
              Validation
            </h4>

            <h5 class="heading-gray text-left my-2">
              Enhancing a course with validation mechanisms ensures effective
              learning. Adding rewards to learning actions elevates the
              experience and also amplifies engagement.
            </h5>
          </vs-row>

          <vs-row class="flex-col lg:flex-row justify-between mt-2 mb-6">
            <vs-col vs-sm="12" vs-lg="5" class="vs-md">
              <div>
                <h5
                  class="heading-black text-left font-semibold text-xl my-2 mb-4"
                >
                  Reward value
                  <span class="heading-gray font-normal">(Optional)</span>
                </h5>
                <div
                  class="flex items-center w-full relative reward__value justify-end"
                >
                  <v-select
                    class="w-3/5"
                    v-validate="'required'"
                    v-model="rewardType"
                    :options="rewardTypeOptions"
                  />

                  <input
                    @keyup.enter="addReward"
                    placeholder="Enter Value"
                    class="px-3 py-3 w-2/5 h-full text-xl place-self-end justify-self-end right-0 border-none"
                    v-model="rewardValue"
                  />
                </div>
              </div>

              <vs-row class="flex lg:hidden my-4" v-if="rewards.length > 0">
                <div
                  v-for="(reward, index) in rewards"
                  :key="reward.key"
                  @click="selectReward(reward, index)"
                  @mouseenter="rewardHovered = reward.key"
                  @mouseleave="rewardHovered = ''"
                  class="reward__pill px-4 py-2 cursor-pointer mr-3 overflow-hidden"
                  :class="[
                    reward.label ? '' : 'hidden',
                    rewardHovered === reward.key ? 'reward__pill-hovered' : '',
                  ]"
                >
                  <h5>{{ reward.value }} {{ reward.label }}</h5>
                  <span
                    v-if="rewardHovered === reward.key && reward.key !== 0"
                    class="reward__pill__remove"
                    @click.stop="removeReward(index)"
                  >
                    <img src="@/assets/images/icons/remove-skill-star.svg" />
                  </span>
                </div>
              </vs-row>
            </vs-col>

            <vs-col class="lg:px-10 xl:px-12 vs-md" vs-sm="12" vs-lg="5">
              <div>
                <h5
                  class="heading-black text-left font-semibold text-xl my-2 mb-4"
                >
                  Validation Type
                </h5>
                <v-select
                  v-validate="'required'"
                  v-model="validationType"
                  :options="validationOptions"
                />
              </div>
            </vs-col>

            <vs-col
              vs-sm="12"
              vs-lg="2"
              class="vs-md flex items-end mt-6 md:lg-0"
            >
              <div
                :style="{ background: orgData.primaryThemeColor }"
                :class="
                  isSubmitValidation ? '' : 'opacity-50 pointer-events-none'
                "
                class="btn-claim text-xl font-semibold rounded-lg py-2 md:py-3 px-4 cursor-pointer w-full"
                @click="submitValidation"
              >
                Submit
              </div>
            </vs-col>
          </vs-row>
          <vs-row class="hidden lg:flex" v-if="rewards.length > 0">
            <div
              v-for="(reward, index) in rewards"
              :key="reward.key"
              @click="selectReward(reward, index)"
              @mouseenter="rewardHovered = reward.key"
              @mouseleave="rewardHovered = ''"
              class="reward__pill px-4 py-2 cursor-pointer mr-3 overflow-hidden"
              :class="[
                reward.label ? '' : 'hidden',
                rewardHovered === reward.key ? 'reward__pill-hovered' : '',
              ]"
            >
              <h5>{{ reward.value }} {{ reward.label }}</h5>
              <span
                v-if="rewardHovered === reward.key && reward.key !== 0"
                class="reward__pill__remove"
                @click.stop="removeReward(index)"
              >
                <img src="@/assets/images/icons/remove-skill-star.svg" />
              </span>
            </div>
          </vs-row>
          <div
            class="absolute w-full left-0"
            v-if="validationType && validationType.key === 'quiz'"
          >
            <hr class="my-4 md:my-8" style="border: 2px solid #eaecf0" />
            <vs-row class="px-4 lg:px-6 pb-4 justify-between">
              <vs-col class="w-full lg:pr-6 lg:w-1/2 quiz-option-container">
                <vs-row
                  class="w-full flex flex-row justify-between question__type"
                >
                  <div
                    v-for="option in quizGenerationOptions"
                    :key="option.optionType"
                    @click="quizGenerationBy = option.optionType"
                    class="px-4 lg:px-6 w-1/2 cursor-pointer"
                    :class="
                      option.optionType === quizGenerationBy
                        ? 'quiz-option-active heading-black'
                        : 'quiz-option'
                    "
                  >
                    <h5
                      class="capitalize mb-1"
                      :class="
                        option.optionType === quizGenerationBy
                          ? 'heading-black font-semibold'
                          : 'heading-gray'
                      "
                    >
                      {{ option.optionType }}
                    </h5>
                  </div>
                </vs-row>

                <vs-row v-if="quizGenerationBy === 'manual'">
                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Question Type
                      </h5>
                      <div>
                        <v-select
                          v-validate="'required'"
                          v-model="manualQuiz.questionType"
                          :options="questionTypeOptions"
                        />
                      </div>
                    </div>
                  </vs-col>

                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Question
                      </h5>

                      <vs-textarea
                        placeholder="Enter your question here"
                        name="question"
                        class="w-full text-lg rounded mb-0 p-2"
                        v-model="manualQuiz.question"
                      />
                    </div>
                  </vs-col>

                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Answer A
                      </h5>
                      <div>
                        <input
                          name="AssignmentUrl"
                          class="p-2 w-full text-xl url-input rounded"
                          v-model="manualQuiz.optionA"
                        />
                      </div>
                    </div>
                  </vs-col>

                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Answer B
                      </h5>
                      <div>
                        <input
                          name="AssignmentUrl"
                          class="p-2 w-full text-xl url-input rounded"
                          v-model="manualQuiz.optionB"
                        />
                      </div>
                    </div>
                  </vs-col>

                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Answer C
                      </h5>
                      <div>
                        <input
                          name="AssignmentUrl"
                          class="p-2 w-full text-xl url-input rounded"
                          v-model="manualQuiz.optionC"
                        />
                      </div>
                    </div>
                  </vs-col>

                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Answer D
                      </h5>
                      <div>
                        <input
                          name="AssignmentUrl"
                          class="p-2 w-full text-xl url-input rounded"
                          v-model="manualQuiz.optionD"
                        />
                      </div>
                    </div>
                  </vs-col>

                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Correct Answer
                      </h5>
                      <div>
                        <v-select
                          v-validate="'required'"
                          v-model="manualQuiz.answer"
                          :options="manualQuiz.choices"
                        />
                      </div>
                    </div>
                  </vs-col>

                  <div
                    @click="addQuiz"
                    :style="{ background: orgData.primaryThemeColor }"
                    class="w-full my-6 btn-claim text-xl font-semibold rounded-lg py-2 px-4 cursor-pointer"
                  >
                    Add Question
                  </div>
                </vs-row>

                <vs-row v-else>
                  <!-- <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Auto Generate
                      </h5>
                      <div>
                        <input
                          name="AssignmentUrl"
                          class="p-2 w-full text-xl url-input rounded"
                          disabled
                          v-model="assignmentUrl"
                        />
                      </div>
                    </div>
                  </vs-col> -->
                  <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Question Type
                      </h5>
                      <div>
                        <v-select
                          v-validate="'required'"
                          v-model="questionType"
                          :options="questionTypeOptions"
                        />
                      </div>
                    </div>
                  </vs-col>
                  <!-- <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Difficulty
                      </h5>
                      <div>
                        <v-select
                          v-validate="'required'"
                          v-model="difficultyLevel"
                          :options="difficultyLevelOptions"
                        />
                      </div>
                    </div>
                  </vs-col> -->
                  <div
                    :style="{ background: orgData.primaryThemeColor }"
                    class="w-full mt-6 btn-claim text-xl font-semibold rounded-lg py-2 px-4 cursor-pointer"
                    @click="generateQuiz"
                  >
                    Generate
                  </div>
                </vs-row>
              </vs-col>
              <vs-col class="lg:pl-6 my-4 lg:my-0 w-full lg:w-1/2">
                <h4
                  v-show="generatedQuiz.length > 0"
                  class="heading-black font-semibold text-left"
                >
                  Your Quiz
                </h4>
                <div
                  v-show="generatedQuiz.length > 0"
                  class="question-box w-full my-4"
                  v-for="(question, i) in generatedQuiz"
                  :key="i"
                >
                  <question
                    :index="i"
                    :question="question"
                    @editQues="editedQues"
                    @deleteQues="deleteQues"
                  />
                </div>
              </vs-col>
            </vs-row>
          </div>

          <div
            class="absolute w-full left-0"
            v-if="validationType && validationType.key === 'attendance'"
          >
            <hr class="my-1 md:my-4" style="border: 2px solid #eaecf0" />
            <vs-row class="px-4 pb-2 lg:px-6 lg:pb-8 justify-between">
              <vs-col class="w-full lg:pr-6 lg:w-1/2 quiz-option-container">
                <vs-row>
                  <!-- <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Auto Generate
                      </h5>
                      <div>
                        <input
                          name="AssignmentUrl"
                          class="p-2 w-full text-xl url-input rounded"
                          disabled
                          v-model="assignmentUrl"
                        />
                      </div>
                    </div>
                  </vs-col> -->
                  <!-- <vs-col class="mt-2">
                    <div>
                      <h5
                        class="heading-black text-left font-semibold text-lg my-2"
                      >
                        Question Type
                      </h5>
                      <div>
                      </div>
                    </div>
                  </vs-col> -->
                  <div
                    :style="{ background: orgData.primaryThemeColor }"
                    class="w-full my-2 lg:mt-6 btn-claim text-xl font-semibold rounded-lg py-2 px-4 cursor-pointer"
                    @click="generateQrCode"
                  >
                    Generate
                  </div>
                </vs-row>
              </vs-col>
              <vs-col
                v-if="qrCode"
                class="lg:pl-6 my-4 lg:my-0 w-full lg:w-1/2"
              >
                <div
                  class="w-full h-full flex flex-col items-center justify-center"
                >
                  <div class="w-1/2 h-1/2 lg:w-64 lg:h-64">
                    <img
                      :src="qrCode"
                      class="w-full h-full object-cover"
                      :alt="qrCode"
                    />
                  </div>
                  <vs-tooltip text="Download QR Code" position="top">
                    <div @click="downloadQrCode" class="flex p-2 icon-border">
                      <feather-icon
                        icon="DownloadIcon"
                        style="
                           {
                            color: #667085;
                          }
                        "
                      />
                    </div>
                  </vs-tooltip>
                  <div class="w-full text-left font-semibold text-lg mt-2 mb-1">
                    or copy link
                  </div>
                  <div
                    class="p-2 link-input w-full flex items-center justify-between"
                  >
                    <span>{{ shortLink }}</span>
                    <vs-tooltip text="Copy QR Code" position="top">
                      <div
                        @click="copyQRLink"
                        class="icon-border cursor-pointer"
                      >
                        <feather-icon
                          icon="CopyIcon"
                          style="
                             {
                              color: #667085;
                            }
                          "
                        />
                      </div>
                    </vs-tooltip>
                  </div>
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vx-card>
      </div>
    </section>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
import Question from "./components/Question.vue";
import QRCode from "qrcode";

export default {
  name: "AddValidationModal",
  data() {
    return {
      rewardType: { key: "", label: "Select Token" },
      rewardValue: "",
      // rewardTypeOptions: [
      //   // { key: 0, label: "XPs"},
      //   // { key: 1, label: "Knowledge Tokens" },
      //   { key: 6, label: "Gold" },
      //   // { key: 3, label: "Key" },
      // ],
      validationOptions: [
        { key: "upload", label: "Upload" },
        { key: "quiz", label: "Quiz" },
        { key: "attendance", label: "QR Code" },
        // { key: "etc", label: "Etc" },
      ],
      validationType: { key: "upload", label: "Upload" },
      //quiz
      assignmentUrl: "",
      quizGenerationBy: "Auto Generate",
      quizGenerationOptions: [
        {
          optionType: "Auto Generate",
        },
        // {
        //   optionType: "text",
        // },
        // {
        //   optionType: "uploads",
        // },
        {
          optionType: "manual",
        },
      ],
      questionTypeOptions: [
        { key: "mcq", label: "Multiple Choice" },
        // { key: "trueorfalse", label: "True or False" },
        // { key: "shortAns", label: "Short Answer" },
        // { key: "blanks", label: "Fill in the blank" },
      ],
      questionType: { key: "mcq", label: "Multiple Choice" },
      difficultyLevelOptions: [
        { key: "mcq", label: "Easy" },
        { key: "medium", label: "Medium" },
        { key: "large", label: "Large" },
      ],
      difficultyLevel: { key: "mcq", label: "Easy" },
      manualQuiz: {
        question: "",
        optionA: "",
        optionB: "",
        optionC: "",
        optionD: "",
        answerChosen: {},
        choices: [{ key: "", label: "Please Select" }],
        answer: {},
        questionType: {},
      },
      generatedQuiz: [],
      quizAnswerChosen: "",
      isSubmitValidation: true,
      rewards: [],
      rewardHovered: "",
      qrCode: "",
      shortLink: "",
    };
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    Question,
  },
  props: {
    assignment: {
      type: Object,
      required: true,
    },
    orgId: {
      type: String,
      required: true,
    },
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    orgAssignments() {
      return this.$store.state.alex.orgAssignments;
    },
    rewardTypeOptions() {
      return this.$store.state.organization.organizationConfiguration.currency
        .values;
    },
  },
  watch: {
    "manualQuiz.optionA": "updateOptions",
    "manualQuiz.optionB": "updateOptions",
    "manualQuiz.optionC": "updateOptions",
    "manualQuiz.optionD": "updateOptions",
    validationType: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (
          newVal &&
          newVal.key === "quiz" &&
          this.rewards &&
          this.generatedQuiz.length === 0
        ) {
          this.isSubmitValidation = false;
        } else if (
          newVal &&
          newVal.key === "attendance" &&
          this.rewards &&
          !this.qrCode
        ) {
          this.isSubmitValidation = false;
        } else {
          this.isSubmitValidation = true;
        }
      },
    },
    rewardType: {
      handler(newVal) {
        if (newVal === null || newVal === undefined) {
          this.rewardType = {};
        } else {
          if (this.rewardValue) {
            const rewardObj = {
              value: parseInt(this.rewardValue),
              ...newVal,
            };

            const indexToUpdate = this.rewards.findIndex(
              (item) => item.key === newVal.key && item.label === newVal.label
            );

            if (indexToUpdate !== -1) {
              this.rewards[indexToUpdate].value = this.rewardValue;
            } else {
              this.rewards.push(rewardObj);
            }

            this.rewardType = {};
            this.rewardValue = "";
          }
        }
      },
    },
    // rewardValue: {
    //   handler(newVal) {
    //     this.rewards = [];
    //     const rewardObj = {
    //       value: parseInt(newVal),
    //       ...this.rewardType,
    //     };

    //     this.rewards.push(rewardObj);

    //     const defaultObj = {
    //       value: parseInt(this.assignment.feedLibraryItem.knowledgeToken),
    //       ...{ key: "0", label: "XPs" },
    //     };
    //     this.rewards.push(defaultObj);
    //   },
    // },
  },
  created() {
    this.assignmentUrl = this.assignment.feedLibraryItem.url;
    // this.rewardValue = this.assignment.feedLibraryItem.knowledgeToken;
    this.getQuiz();

    const defaultObj = {
      value: parseInt(
        this.assignment.feedLibraryItem.xp ||
          this.assignment.feedLibraryItem.knowledgeToken
      ),
      ...{ key: 0, label: "XPs" },
    };
    this.rewards.push(defaultObj);

    if (this.assignment.feedLibraryItem.gold) {
      const defaultObj = {
        value: parseInt(this.assignment.feedLibraryItem.gold),
        ...{ key: 6, label: "Gold" },
      };
      this.rewards.push(defaultObj);
    }

    if (this.assignment.libraryItemValidationData) {
      this.getValidation();
    }
  },
  // created() {
  //   this.getQuiz();
  //   this.getValidation();
  // },
  methods: {
    generateRandomString(inputString) {
      if (!inputString) {
        inputString = "random";
      }
      const maxLength = Math.ceil(inputString.length / 2);
      const characters =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let randomString = "";

      for (let i = 0; i < maxLength; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        randomString += characters[randomIndex];
      }
      return randomString;
    },
    updateOptions() {
      this.manualQuiz.choices = [
        {
          key: `q${this.generatedQuiz.length + 1}-${this.generateRandomString(
            this.manualQuiz.optionA
          )}_optionA`,
          label: this.manualQuiz.optionA,
        },
        {
          key: `q${this.generatedQuiz.length + 1}-${this.generateRandomString(
            this.manualQuiz.optionA
          )}_optionB`,
          label: this.manualQuiz.optionB,
        },
        {
          key: `q${this.generatedQuiz.length + 1}-${this.generateRandomString(
            this.manualQuiz.optionA
          )}_optionC`,
          label: this.manualQuiz.optionC,
        },
        {
          key: `q${this.generatedQuiz.length + 1}-${this.generateRandomString(
            this.manualQuiz.optionA
          )}_optionD`,
          label: this.manualQuiz.optionD,
        },
      ];
    },
    addQuiz() {
      const payload = {
        organizationId: this.orgId,
        feedItemId: this.assignment.itemId,
        question: this.manualQuiz.question,
        questionType: this.manualQuiz.questionType.key,
        choices: this.manualQuiz.choices,
        answer: this.manualQuiz.answer.key,
        answerText: this.manualQuiz.answer.label,
      };

      this.$store
        .dispatch("organization/createQuiz", payload)
        .then((res) => {
          if (res.data && res.data._id) {
            this.generatedQuiz.push({
              ...this.manualQuiz,
              answer: this.manualQuiz.answer.key,
              answerText: this.manualQuiz.answer.label,
            });
            this.manualQuiz = {};
            this.manualQuiz.choices = [{ key: "", label: "Please Select" }];
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
    getQuiz() {
      this.$vs.loading();
      const payload = {
        orgId: this.orgId,
        itemId: this.assignment.itemId,
      };
      this.$store
        .dispatch("organization/fetchQuiz", payload)
        .then((res) => {
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const newObj = {
                answerChosen: {
                  key: res.data[i].answer,
                  label: res.data[i].answerText,
                },
                ...res.data[i],
              };
              for (const item of res.data[i].choices) {
                const key = item.key.split("_")[1];
                newObj[key] = item.label;
              }
              this.generatedQuiz.push(newObj);
            }
          }
        })
        .catch((err) => {
          // console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deleteQues(index) {
      this.generatedQuiz.splice(index, 1);
    },
    editedQues(value) {
      const payload = {
        organizationId: this.orgId,
        feedItemId: this.assignment.itemId,
        question: value.updatedQues.question,
        questionType: value.updatedQues.questionType,
        choices: value.updatedQues.choices,
        answer: value.updatedQues.answerChosen.key,
        answerText: value.updatedQues.answerChosen.label,
        _id: value.updatedQues._id,
      };

      if (value.index >= 0 && value.index < this.generatedQuiz.length) {
        this.generatedQuiz[value.index] = value.updatedQues;
        this.$store
          .dispatch("organization/updateQuestion", payload)
          .then((res) => {
            console.log(res);
          })
          .catch(() => {});
        this.$forceUpdate();
      }
    },
    submitValidation() {
      const payload = {
        gtbrddOrganizationId: this.orgId,
        feedItemId: this.assignment.itemId,
        validationType: this.validationType.key,
        tokens: this.rewards,
      };
      this.$store
        .dispatch("alex/assignValidation", payload)
        .then((res) => {
          if (res && res.data && res.data._id) {
            let index = this.orgAssignments.findIndex((item) => {
              return item.itemId === payload.feedItemId;
            });
            if (index > -1) {
              this.orgAssignments[index].libraryItemValidationData = payload;
              this.$store.commit("modals/OPEN_ADD_VALIDATION_POPUP", false);
              this.$forceUpdate();
            }
          }
        })
        .catch(() => {});
    },
    removeReward(index) {
      this.rewards.splice(index, 1);
    },
    selectReward(reward, index) {
      // console.log(this.rewardType, this.rewardValue, index);
    },
    addReward() {
      const rewardObj = {
        value: parseInt(this.rewardValue),
        ...this.rewardType,
      };

      const indexToUpdate = this.rewards.findIndex(
        (item) =>
          item.key === this.rewardType.key &&
          item.label === this.rewardType.label
      );

      if (indexToUpdate !== -1) {
        this.rewards[indexToUpdate].value = this.rewardValue;
      } else {
        this.rewards.push(rewardObj);
      }

      this.rewardType = {};
      this.rewardValue = "";
    },
    generateQuiz() {
      const payload = {
        orgId: this.orgId,
        itemId: this.assignment.itemId,
      };

      this.$store
        .dispatch("alex/fetchQuiz", payload)
        .then((res) => {
          if (typeof res === "object" && res.length > 0) {
            this.generatedQuiz = res;
            this.isSubmitValidation = true;
            for (let i = 0; i < res.length; i++) {
              this.$store.dispatch("organization/createQuiz", {
                ...res[i],
                organizationId: this.orgId,
              });
            }
          } else {
            this.$vs.notify({
              text: "A validation quiz is queued for processing. Validation quiz is not ready yet. It may take upto 24 hours, please check back later.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
            });
          }
        })
        .catch(() => {});
    },
    generateQrCode() {
      this.$vs.loading();
      event.stopPropagation();
      const itemId = this.assignment.itemId;
      this.$store
        .dispatch("organization/fetchAttendanceToken", {
          organizationId: this.orgId,
          eventData: this.assignment,
          feedItemId: itemId,
        })
        .then((res) => {
          if (res && res.data && res.data.shortUrl) {
            this.generateQrCodeImg(itemId, res.data.shortUrl);
            this.shortLink = res.data.shortUrl;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    async generateQrCodeImg(itemId, url) {
      const options = {
        // errorCorrectionLevel: "L", // High error correction level
        // maskPattern:10,
        margin: 2, // Increase the margin size around the QR code
        width: 300, // Increase the width and height of the QR code
        color: {
          dark: "#000", // Dark color for the QR code squares
          light: "#fff", // Light color for the background
        },
        rendererOpts: {
          quality: 1.0, // Adjust the rendering quality (1.0 is the highest quality)
        },
      };
      try {
        // let url = `https://getboarded.com/`;
        this.qrCode = await QRCode.toDataURL(url, options);
        this.isSubmitValidation = true;
      } catch (err) {
        console.error(err);
      }
    },
    downloadQrCode() {
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = this.qrCode;
      a.download = `${this.assignment.feedLibraryItem.title}__qr__code.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    getValidation() {
      this.$vs.loading();
      this.$store
        .dispatch("alex/fetchItemValidationDetails", {
          orgId: this.orgId,
          itemId: this.assignment.itemId,
        })
        .then((res) => {
          if (res && res.data) {
            const validationObj = this.validationOptions.find(
              (validate) => validate.key === res.data.validationType
            );
            this.validationType = validationObj;

            if (
              this.assignment.libraryItemValidationData.validationType ===
              "quiz"
            ) {
              this.getQuiz();
            } else if (
              this.assignment.libraryItemValidationData.validationType ===
              "attendance"
            ) {
              this.generateQrCode();
            } else {
              this.$vs.loading.close();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    copyQRLink() {
      navigator.clipboard
        .writeText(this.shortLink)
        .then(() => {
          this.$vs.notify({
            text: "Link copied successfully",

            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
            fixed: false,
          });
        })
        .catch((err) => {
          console.error("Unable to copy text to clipboard", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.cross-icon {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
  top: 0;
  font-size: 1.5em;
  padding: 0.5em;
  border-radius: 50%;
  height: 2em;
  width: 2em;
  top: 0;
  right: 0;
  transition: all 0.23s ease 0.1s;
  transform: translate(8px, -2px);
  font-family: "Montserrat", Helvetica, Arial, serif;
  background: #fffffffa;
  // For hover effect of close btn
  &:hover,
  &:focus,
  &:active {
    opacity: 1;
    outline: none;
    transform: translate(5px, 3px);
    box-shadow: none;
  }
}

.reward__pill {
  border: 2px solid #d0d5dd;
  border-radius: 2rem;
  text-transform: capitalize;
  width: max-content;
  display: flex;
  gap: 1rem;
  height: fit-content;
  align-items: center;
  position: relative;

  &-hovered {
    background: #f2f4f7;
  }

  h5 {
    color: #000 !important;
  }

  &__remove {
    position: absolute;
    right: 0rem;
    background-color: white;
    padding: 0.6rem;
    border-radius: 2rem;

    img {
      width: 1.7rem;
      height: auto;
      opacity: 1;
      background-color: white;
    }
  }
}
.link-input {
  border: 2px solid #d0d5dd;
  border-radius: 0.25rem;
}
.scrollbarWidth::-webkit-scrollbar {
  width: 10px;
}
.scrollbarWidth::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(41, 39, 39, 0.3);
  border-radius: 10px;
}
.scrollbarWidth::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 20px #c1c1c1;
}

.quiz-option {
  border-bottom: 2px solid #eaecf0;

  &-active {
    border-bottom: 2px solid #f8c62c;
  }
  &-container {
    height: max-content;
    position: sticky;
    top: 2rem;
  }
}
.skeleton {
  position: relative;
  margin: 2em 0;
  padding: 10em 0;
  border-radius: 10px;
  background: rgb(128, 128, 128);
  animation: flicker-light 1s infinite alternate;
}
@keyframes flicker-light {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.2;
  }
}
.b-dropdown ::v-deep .dropdown-toggle {
  white-space: normal;
}

.add-validation__modal {
  &__container {
    background: #0000006a;
    backdrop-filter: blur(5px);
    position: fixed !important;
    width: 100%;
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 100000;
    .vs-tooltip {
      z-index: 5200000;
    }
    .heading {
      &-black {
        color: #000000 !important;
      }
      &-gray {
        color: #948f8f !important;
      }
      &-red {
        color: #ff6584 !important;
      }
    }

    .url-input {
      border: 1px solid rgba(60, 60, 60, 0.26);
    }

    .btn {
      &-claim {
        background: #f8c62c;
        color: #fff;
      }
      &-done {
        background: #25cc9a;
        &-2 {
          background: #25cc9a1a;
        }
      }
    }

    .gradient-bg {
      background: linear-gradient(270deg, #e0ecff 0%, #ffeab4 100%);
    }
    .coin {
      left: -0.875rem;
    }
    .overflow-container {
      height: auto;
      &-quiz {
        // overflow-y: scroll;
        height: 90vh;
      }
    }
    .border {
      border: 2px solid #efefef;
    }
    .token-box {
      border-radius: 0.5rem;
      border: 1px solid #fff;
      background: #fff;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25) inset,
        0px 4px 10px 0px rgba(0, 0, 0, 0.1);

      h6 {
        color: #676767 !important;
        text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
        font-weight: 500;
        right: 0;
        bottom: -10px;
      }
    }
    .card-shadow {
      box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.1);
    }
  }
}

.question-box {
  border-radius: 0.375rem;
  border: 1px solid #efefef;

  &-option {
    color: #948f8f;
  }
}
@media (max-width: 992px) {
  .vs-md {
    width: 100% !important;
  }

  .add-validation__modal {
    &__container {
      .overflow-container {
        height: auto;
        &-quiz {
          // overflow-y: scroll;
          height: auto;
          background: #fff;
          border-radius: 0.25rem;
        }
      }
    }
  }
}

.v-select ::v-deep .vs__dropdown-toggle {
  padding: 0.6rem 0;
  min-width: 10rem;
}

.vs-con-textarea ::v-deep .vs-textarea {
  font-size: 1.125rem;
}

.question__type {
  border-bottom: 2px solid #eaecf0;

  div {
    margin-bottom: -2px;
  }
}

.reward__value {
  border: 1px solid #cccccc;
  border-radius: 0.3rem;

  input {
    z-index: 0;
    background-color: transparent;
  }

  .v-select ::v-deep .vs__dropdown-toggle {
    border: none;
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
  }
}
</style>
